<app-header></app-header>
<!--   
<section class="bg-half-170 bg-light d-table w-100" style="background: url('assets/images/foods.jpeg') center center;" id="home">
  <div class="bg-overlay"></div>
  <div class="container " >
          <div class="col-lg-12 text-center">
              <div class="pages-heading">
                  <h4 class="title text-white title-dark mb-0"> Souvenirs </h4>
              </div>
          </div> 
      <div class="position-breadcrumb">
          <nav aria-label="breadcrumb" class="d-inline-block">
              <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li class="breadcrumb-item"><a routerLink="">Blimp</a></li>
                  <li class="breadcrumb-item"><a>Souvenirs</a></li>
              </ul>
          </nav>
      </div>
  </div>
</section> -->
<!--end section-->
        <!-- <div class="position-relative">
            <div class="shape overflow-hidden text-color-white">
                <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>  -->
    <section class="bg-half" id="home">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
            <div class="section-title text-center mb-4 pb-2">
                <h4 ><span class="text-primary">Souvenirs</span></h4>
                <p class="text-muted para-desc mx-auto mb-0">The <span
                        class="text-primary fw-bold">unique souvenirs</span> around the world</p>
            </div>
        </div>
        <!--end col-->
    </div>
      <div class="row align-items-center">
        <div class="col-lg-9 col-md-7">
            <div class="section-title">
                <h5 class="mb-0">Souvenirs Results</h5>
            </div>
        </div><!--end col-->

        <div *ngIf="modelObject"  class="col-lg-3 col-md-5 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div class="d-flex justify-content-md-between align-items-center">
                <div class="form custom-form">
                    <div class="mb-0">
                      <select  placeholder="Selecte Country" [(ngModel)]="modelObject.countryId" (change)="getByCountry()" class="form-select form-control" aria-label="Default select example" id="Sortbylist-job">
                        <option [value]="0">All</option>
                        <option  *ngFor="let data of CountriesList" [value]="data.id">{{data.nameEn}}</option>
                    </select>
                    </div>
                </div>
            </div>
        </div><!--end col-->
     </div><!--end row-->     
        <div class="row container-grid projects-wrapper">
          <div class="col-lg-3 col-md-6 col-12 spacing mt-3 branding" *ngFor="let item of rows">
            <div class="card border-0 work-container work-grid position-relative d-block overflow-hidden rounded">
              <div class="card-body p-0" routerLink="/souvenirs-details/{{item.id}}">
                <a class="mfp-image d-inline-block"  title="">
                  <img src="{{item.images}}" class="img-fluid" style="height: 200px; width: 100%;" alt="work-image">
                </a>
                <div class="content bg-white p-3">
                  <h5 class="mb-0"><a routerLink="/souvenirs-details/{{item.id}}" class="text-dark title">{{item.nameEn}}</a></h5>
                  <!-- <h6 class="text-muted tag mb-0">{{item.category}}</h6> -->
                  <span class="text-muted">
                    <ngb-rating [max]="5" [(rate)]="item.averageStar" [readonly]="true" style="font-size: 25px;">
                    </ngb-rating>
                </span>
                </div>
              </div>
            </div>
          </div>
          <!--end col-->
    
        </div>
        <div class="col-12 mt-4 pt-2">
            <ul class="pagination justify-content-center mb-0">
                <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Previous"><i class="mdi mdi-arrow-left"></i> Prev</a></li>
                <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
                <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
                <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
                <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Next">Next <i class="mdi mdi-arrow-right"></i></a></li>
            </ul>
        </div><!--end col-->
        <!--end row-->
      </div>
    <!--end container-->
  </section>
 
  <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
    <i-feather name="arrow-up" class="icons"></i-feather>
  </a>